import { css } from '@linaria/core';
export const Root = {
    base: css `
		z-index: 2;
		left: 0;
		width: 100%;
		padding-top: 5px;
	`,
};
export const ProgressBar = {
    base: css `
		overflow: hidden;

		width: 100%;
		height: 3px;
		border-radius: 3px;

		background: rgba(var(--global-text), 0.45);
	`,
};
export const Bar = {
    base: css `
		float: left;
		width: 100%;
		height: 100%;
		background: rgb(var(--brand-dark-secondary));
	`,
    type: {
        media: null,
        text: null,
        collection: null,
        picture: null,
        card: null,
        show: null,
        program: css `
			background: rgb(var(--brand-live));
		`,
        live: css `
			background: rgb(var(--brand-live));
		`,
    },
};
